/* BackToTop - Floating bosgroen scroll-to-top control positioned above fixed purchase CTAs with a stronger background shadow.
   Updated: Lowered together with the WhatsApp button, still stacked and centred above it. */

import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          onClick={scrollToTop}
          className="fixed bottom-[9rem] right-[26px] z-50 p-3 rounded-full transition-all duration-300 hover:scale-110 shadow-[0_8px_24px_rgba(0,0,0,0.28)] sm:bottom-[10rem]"
          style={{
            backgroundColor: '#1e2b22',
            border: '2px solid white',
          }}
          aria-label="Back to top"
        >
          <ChevronUp className="w-6 h-6 text-white" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
